/* eslint-disable @typescript-eslint/no-explicit-any */
import { isProcessData } from "./tableUtils";

export const getCellFilter = (column: any, data: any): any[] => {
  let cellValue: any[] = [];
  if (isProcessData(column.key)) {
    cellValue = [data[column.key + "_state"]];
  } else if (column.cellFilterValue) {
    cellValue = column.cellFilterValue(data, column);
  } else {
    cellValue = [data[column.key]];
  }

  cellValue = (cellValue || []) as any[];
  return cellValue.filter(
    (item: any) => item != null && item != undefined && item !== ""
  );
};

export const getCellCopyData = (column: any, data: any): any[] => {
  let cellValue: any[] = [];
  if (column.cellCopyData) {
    cellValue = column.cellCopyData(data, column);
  } else {
    cellValue = [data[column.key]];
  }

  cellValue = (cellValue || []) as any[];
  return cellValue.filter(
    (item: any) => item != null && item != undefined && item !== ""
  );
};
